import { Observable } from 'rxjs';
import { map, pluck, filter } from 'rxjs/operators';

import {
  authActions,
  configActions,
  errorActions,
  pingActions,
} from '../../actions';
import { configActionsFromSlice } from '../../reducers/config';

const { ping } = pingActions;
const { auth } = authActions;

const config = process.env.NODE_ENV !== 'test'
  ? configActions.config : (configActions.config || configActionsFromSlice);

const configErrorsEpic = (action$: Observable<any>) => action$.pipe(
  filter((action) => config.failure.type === action.type
  || auth.failure.type === action.type
  || ping.failure.type === action.type),
  pluck('payload'),
  map(errorActions.error.set)
);

export default configErrorsEpic;
